import { EHostModalType, IHostModalsData } from 'components/HostModals/types';
import { IArgs } from 'hooks/useHostContextMenuItems/interfaces';

export const getContextMenuFunctions = (
  hostModalsState: IHostModalsData
): IArgs => ({
  openStartSeanceModal: () => hostModalsState.setType(EHostModalType.SHOP),
  openAllBookingsModal: () => {
    hostModalsState.setType(EHostModalType.ALL_BOOKINGS);
  },
  openBookingModal: () => {
    hostModalsState.setType(EHostModalType.BOOKING);
  },
  openStopClientSessionModal: () => {
    hostModalsState.setType(EHostModalType.STOP_CLIENT_SESSION);
  },
  openRunFileModal: () => {
    hostModalsState.setType(EHostModalType.RUN_FILE);
  },
  openHostCommentsModal: () => {
    hostModalsState.setType(EHostModalType.COMMENTS);
  },
  openHostMessageModal: () => {
    hostModalsState.setType(EHostModalType.SEND_MESSAGE);
  },
  openHostTimeDownModal: (host, penalty) => {
    hostModalsState.setType(EHostModalType.PENALTY);
    hostModalsState.setPenalty(penalty);
  },
  openDepositModal: () => {
    hostModalsState.setType(EHostModalType.CLIENT_DEPOSIT);
  },
  openManageHostModal: () => {
    hostModalsState.setType(EHostModalType.MANAGE_HOST);
  },
  openChangeHostModal: () => {
    hostModalsState.setType(EHostModalType.MOVE_SESSION);
  },
  openGeneratePinModal: () =>
    hostModalsState.setType(EHostModalType.GENERATE_PIN),
  openGenerateQrModal: () => {
    hostModalsState.setType(EHostModalType.GENERATE_QR);
  },
  selectedHostsIds: hostModalsState.selectedHostsIds,
  unselectHosts: hostModalsState.unselectHosts,
  hosts: hostModalsState.hosts,
});
